export default __webpack_public_path__ + "354d361.png";